// extracted by mini-css-extract-plugin
export default {"container":"UUN0-","wrapper":"HDgC7","title":"HxidV","icon":"ML0VJ"};